module.exports = __webpack_public_path__ + "img/smtp.2d9e9ba8.svg";